import {Component, inject} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {APP_MODAL_REF} from '../../../constants/modal/app-modal-ref.constant';
import {AppButtonTypeEnum} from '../../../enums/button/app-button-type.enum';
import {ButtonColorEnum} from '../../../enums/button/button-color.enum';
import {AppConfirmDialogData} from '../../../models/modal/dialog/app-confirm-dialog-data.model';
import {AppDialogModal} from '../../../models/modal/dialog/app-dialog-modal.model';
import {ModalService} from '../../../services/modal/modal.service';
import {ButtonComponent} from '../../buttons/button/button.component';

@Component({
    selector: 'app-confirm-dialog-modal',
    imports: [
        ButtonComponent,
        TranslatePipe
    ],
    templateUrl: './confirm-dialog-modal.component.html',
})
export class ConfirmDialogModalComponent {
    public readonly modalData: AppConfirmDialogData;
    protected readonly qaTag: string;
    protected readonly AppButtonTypeEnum = AppButtonTypeEnum;
    protected readonly shouldUseFixedDialogWidth: boolean;
    protected readonly ButtonColorEnum = ButtonColorEnum;
    protected readonly messageCssClass: string;
    private readonly modalRef = inject<AppDialogModal<ConfirmDialogModalComponent, AppConfirmDialogData, boolean>>(APP_MODAL_REF);
    private readonly modalService = inject(ModalService);

    public constructor() {
        this.qaTag = this.modalRef.qaTag;
        this.modalData = this.modalRef.modalData;
        this.shouldUseFixedDialogWidth = !this.modalData.shouldUseFluidDialogWidth;
        this.messageCssClass = this.modalData.shouldPreserveMessageFormatting ? 'modal-dialog-preformatted-message' : 'modal-dialog-message';
    }

    protected confirm(): void {
        this.modalService.closeModal(this.modalRef, true);
    }

    protected cancel(): void {
        this.modalService.closeModal(this.modalRef, false);
    }
}
